import { render, staticRenderFns } from "./create-webinar-details.html?vue&type=template&id=27ce263a&scoped=true&external"
import script from "./create-webinar-details.js?vue&type=script&lang=js&external"
export * from "./create-webinar-details.js?vue&type=script&lang=js&external"
import style0 from "./create-webinar-details.scss?vue&type=style&index=0&id=27ce263a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce263a",
  null
  
)

export default component.exports